<div class="page-container" [class.player-active]="currentTrack">
  <div class="music-player-container">
    <div class="player-header">
      <div class="header-content">
        <h1>{{ 'MUSIC.EXPLORE_SOUNDS' | translate }}</h1>
        <p>{{ 'MUSIC.DISCOVER_DESCRIPTION' | translate }}</p>
        <div class="header-stats">
          <div class="stat-item">
            <span class="stat-number">{{ allTracks.length }}</span>
            <span class="stat-label">{{ 'MUSIC.TOTAL_TRACKS' | translate }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">{{ categories.length }}</span>
            <span class="stat-label">{{ 'MUSIC.CATEGORIES_LABEL' | translate }}</span>
          </div>
        </div>
      </div>
      <div class="header-visual">
        <div class="sound-wave">
          @for (bar of [1,2,3,4,5,6,7,8]; track bar) {
            <div class="wave-bar" [style.animation-delay]="bar * 0.1 + 's'"></div>
          }
        </div>
      </div>
    </div>

    <div class="search-filters">
      <div class="search-container">
        <div class="search-bar">
          <i class="fas fa-search"></i>
          <input
            type="text"
            [(ngModel)]="searchQuery"
            (input)="applyFilters()"
            placeholder="{{ 'MUSIC.SEARCH_PLACEHOLDER' | translate }}"
            >
          @if (searchQuery) {
            <button class="clear-search" (click)="searchQuery = ''; applyFilters()">
              <i class="fas fa-times"></i>
            </button>
          }
        </div>
        <button class="filter-toggle" (click)="toggleFilterPanel()" [class.active]="isFilterPanelOpen">
          <i class="fas fa-filter"></i>
          <span>{{ 'MUSIC.FILTERS' | translate }}</span>
          @if (activeFilters.length > 0) {
            <span class="filter-count">{{ activeFilters.length }}</span>
          }
        </button>
      </div>

      <div class="filters-panel" [class.open]="isFilterPanelOpen">
        <div class="filters-row">
          <div class="filter-group">
            <label>{{ 'MUSIC.CATEGORY' | translate }}</label>
            <select [(ngModel)]="selectedCategory" (change)="applyFilters()">
              <option value="all">{{ 'MUSIC.ALL_CATEGORIES' | translate }}</option>
              @for (category of categories; track category) {
                @if (category.id !== 'all') {
                  <option [value]="category.id">
                    {{ 'MUSIC.CATEGORIES.' + category.id.toUpperCase() | translate }}
                  </option>
                }
              }
            </select>
          </div>

          <div class="filter-group">
            <label>{{ 'MUSIC.MOOD' | translate }}</label>
            <select [(ngModel)]="selectedMood" (change)="applyFilters()">
              <option value="all">{{ 'MUSIC.ALL_MOODS' | translate }}</option>
              @for (mood of moods; track mood) {
                @if (mood.id !== 'all') {
                  <option [value]="mood.id">
                    {{ 'MUSIC.MOODS.' + mood.id.toUpperCase() | translate }}
                  </option>
                }
              }
            </select>
          </div>

          <div class="filter-group">
            <label>{{ 'MUSIC.SORT_BY' | translate }}</label>
            <select [(ngModel)]="sortBy" (change)="changeSortBy(sortBy)">
              <option value="relevance">{{ 'MUSIC.RELEVANCE' | translate }}</option>
              <option value="title">{{ 'MUSIC.TITLE' | translate }}</option>
              <option value="artist">{{ 'MUSIC.ARTIST' | translate }}</option>
              <option value="duration">{{ 'MUSIC.DURATION' | translate }}</option>
            </select>
          </div>

          @if (activeFilters.length > 0) {
            <button class="reset-filters" (click)="resetFilters()">
              <i class="fas fa-undo"></i>
              {{ 'MUSIC.RESET_FILTERS' | translate }}
            </button>
          }
        </div>

        @if (activeFilters.length > 0) {
          <div class="active-filters">
            @for (filter of activeFilters; track filter) {
              <span class="filter-tag" (click)="removeFilter(filter)">
                {{ filter }}
                <i class="fas fa-times"></i>
              </span>
            }
          </div>
        }
      </div>
    </div>

    @if (selectedCategory === 'all' && selectedMood === 'all' && searchQuery === '') {
      <div class="featured-tracks">
        <div class="section-header">
          <h2>{{ 'MUSIC.FEATURED' | translate }}</h2>
          <div class="view-controls">
            <button class="view-btn" [class.active]="viewMode === 'grid'" (click)="changeViewMode('grid')">
              <i class="fas fa-th"></i>
            </button>
            <button class="view-btn" [class.active]="viewMode === 'list'" (click)="changeViewMode('list')">
              <i class="fas fa-list"></i>
            </button>
          </div>
        </div>
        <div class="featured-grid" [class.list-view]="viewMode === 'list'">
          @for (track of allTracks | slice:0:6; track trackByFn($index, track)) {
            <div
              class="featured-track"
              [class.active]="currentTrack?.id === track.id"
              [class.playing]="currentTrack?.id === track.id && isPlaying"
              (click)="playTrack(track)"
              >
              <div class="track-artwork">
                <div class="artwork-bg" [style.background]="'linear-gradient(45deg, ' + getMoodColor(track.mood[0]) + ', ' + getMoodColor(track.mood[1] || track.mood[0]) + ')'"></div>
                @if (track.imageUrl) {
                  <img
                    class="cover-image"
                    [src]="track.imageUrl"
                    [alt]="track.title + ' cover'"
                    loading="lazy"
                    />
                }
                <div class="play-overlay">
                  <div class="play-button">
                    <i [class]="currentTrack?.id === track.id && isPlaying ? 'fas fa-pause' : 'fas fa-play'"></i>
                  </div>
                </div>
                @if (currentTrack?.id === track.id && isPlaying) {
                  <div class="track-waveform">
                    @for (line of [1,2,3,4,5]; track line) {
                      <div class="wave-line" [style.animation-delay]="line * 0.1 + 's'"></div>
                    }
                  </div>
                }
              </div>
              <div class="track-details">
                <h3>{{ track.title }}</h3>
                <p>{{ track.artist }}</p>
                <div class="track-meta">
                  <span class="duration">{{ track.duration }}</span>
                  <div class="track-tags">
                    <span class="category-tag">{{ getCategoryName(track.category) }}</span>
                    @for (mood of track.mood.slice(0,2); track mood) {
                      <span class="mood-tag" [style.background-color]="getMoodColor(mood)">{{ mood }}</span>
                    }
                  </div>
                </div>
                <div class="track-actions">
                  <button class="action-btn like" title="{{ 'MUSIC.LIKE' | translate }}">
                    <i class="fas fa-heart"></i>
                  </button>
                  <button class="action-btn download" (click)="$event.stopPropagation(); downloadTrack(track)" title="{{ 'MUSIC.DOWNLOAD' | translate }}">
                    <i class="fas fa-download"></i>
                  </button>
                  <button class="action-btn share" title="{{ 'MUSIC.SHARE' | translate }}">
                    <i class="fas fa-share"></i>
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }

    <div class="tracks-section">
      <div class="section-header">
        <h2>{{ selectedCategory === 'all' ? ('MUSIC.ALL_TRACKS' | translate) : ('MUSIC.CATEGORIES.' + selectedCategory.toUpperCase() | translate) }}</h2>
        <div class="results-info">
          <span class="results-count">{{ filteredTracks.length }} {{ 'MUSIC.RESULTS' | translate }}</span>
        </div>
      </div>

      <div class="tracks-container" [class.list-view]="viewMode === 'list'" [class.grid-view]="viewMode === 'grid'">
        @for (track of getCurrentPageTracks(); track trackByFn($index, track)) {
          <div
            class="track-item"
            [class.active]="currentTrack?.id === track.id"
            [class.playing]="currentTrack?.id === track.id && isPlaying"
            (click)="playTrack(track)"
            >
            <div class="track-info">
              <div class="track-artwork-small">
                <div class="artwork-bg" [style.background]="'linear-gradient(45deg, ' + getMoodColor(track.mood[0]) + ', ' + getMoodColor(track.mood[1] || track.mood[0]) + ')' "></div>
                @if (track.imageUrl) {
                  <img
                    class="cover-image"
                    [src]="track.imageUrl"
                    [alt]="track.title + ' cover'"
                    loading="lazy"
                    />
                }
                <div class="play-button-small">
                  <i [class]="currentTrack?.id === track.id && isPlaying ? 'fas fa-pause' : 'fas fa-play'"></i>
                </div>
                @if (currentTrack?.id === track.id && isPlaying) {
                  <div class="mini-waveform">
                    @for (wave of [1,2,3]; track wave) {
                      <div class="mini-wave" [style.animation-delay]="wave * 0.15 + 's'"></div>
                    }
                  </div>
                }
              </div>
              <div class="track-details">
                <span class="track-title">{{ track.title }}</span>
                <span class="track-artist">{{ track.artist }}</span>
                <div class="track-tags-inline">
                  <span class="category-tag-small">{{ getCategoryName(track.category) }}</span>
                  @for (mood of track.mood.slice(0,1); track mood) {
                    <span class="mood-tag-small" [style.background-color]="getMoodColor(mood)">{{ mood }}</span>
                  }
                </div>
              </div>
            </div>
            <div class="track-meta">
              <span class="track-duration">{{ track.duration }}</span>
              <div class="track-actions-inline">
                <button class="action-btn-small like" title="{{ 'MUSIC.LIKE' | translate }}">
                  <i class="fas fa-heart"></i>
                </button>
                <button class="action-btn-small download" (click)="$event.stopPropagation(); downloadTrack(track)" title="{{ 'MUSIC.DOWNLOAD' | translate }}">
                  <i class="fas fa-download"></i>
                </button>
                <button class="action-btn-small more" (click)="$event.stopPropagation(); showTrackDetails(track)" title="{{ 'MUSIC.MORE_INFO' | translate }}">
                  <i class="fas fa-ellipsis-h"></i>
                </button>
              </div>
            </div>
          </div>
        }

        @if (filteredTracks.length === 0) {
          <div class="no-results">
            <div class="no-results-content">
              <i class="fas fa-music"></i>
              <h3>{{ 'MUSIC.NO_RESULTS' | translate }}</h3>
              <p>{{ 'MUSIC.NO_RESULTS_DESC' | translate }}</p>
              <button class="reset-btn" (click)="resetFilters()">{{ 'MUSIC.RESET_FILTERS' | translate }}</button>
            </div>
          </div>
        }
      </div>

      @if (totalPages > 1) {
        <div class="pagination">
          <button class="page-btn" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">
            <i class="fas fa-chevron-left"></i>
          </button>
          @for (page of getPageNumbers(); track page) {
            <button
              class="page-btn"
              [class.active]="page === currentPage"
              (click)="goToPage(page)"
              >
              {{ page }}
            </button>
          }
          <button class="page-btn" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      }
    </div>

    <div class="player-controls" [class.active]="currentTrack">
      <div class="now-playing">
        @if (currentTrack) {
          <div class="track-info">
            <div class="track-artwork small">
              @if (currentTrack?.imageUrl) {
                <img
                  class="cover-image"
                  [src]="currentTrack.imageUrl"
                  [alt]="currentTrack.title + ' cover'"
                  loading="lazy"
                  />
              }
            </div>
            <div class="track-details">
              <span class="track-title">{{ currentTrack.title }}</span>
              <span class="track-artist">{{ currentTrack.artist }}</span>
            </div>
            @if (currentTrack) {
              <button class="download-button small" (click)="downloadTrack(currentTrack)">
                <i class="fas fa-download"></i>
              </button>
            }
          </div>
        }
      </div>

      <div class="main-controls">
        <div class="control-buttons">
          <button class="control-btn" (click)="toggleShuffle()" [class.active]="shuffle">
            <i class="fas fa-random"></i>
          </button>
          <button class="control-btn" (click)="previousTrack()">
            <i class="fas fa-step-backward"></i>
          </button>
          <button class="control-btn play-btn" (click)="togglePlay()">
            <i [class]="isPlaying ? 'fas fa-pause' : 'fas fa-play'"></i>
          </button>
          <button class="control-btn" (click)="nextTrack()">
            <i class="fas fa-step-forward"></i>
          </button>
          <button class="control-btn" (click)="toggleRepeat()" [class.active]="repeat !== 'none'">
            <i [class]="repeat === 'one' ? 'fas fa-repeat-1' : 'fas fa-repeat'"></i>
          </button>
        </div>

        <div class="progress-container">
          <span class="time">{{ currentTime | time }}</span>
          <div
            class="progress-bar"
            (mousedown)="startSeek($event)"
            (mousemove)="seeking($event)"
            (mouseup)="endSeek()"
            (mouseleave)="endSeek()"
            >
            <div class="progress" [style.width]="progress + '%'"></div>
          </div>
          <span class="time">{{ duration | time }}</span>
        </div>
      </div>

      <div class="volume-control">
        <i class="fas" [class.fa-volume-up]="volume > 50" [class.fa-volume-down]="volume <= 50 && volume > 0" [class.fa-volume-mute]="volume === 0"></i>
        <input
          type="range"
          min="0"
          max="100"
          [value]="volume"
          (input)="setVolume($event)"
          >
      </div>
    </div>
  </div>
</div>
